import { immerable } from "immer";

export type MagazineCategoryType = {
  id: number;
  name: string;
  slug: string;
};

export class MagazineCategory implements MagazineCategoryType {
  [immerable] = true;

  id = 0;
  name = "";
  slug = "";

  constructor(data: Partial<MagazineCategoryType> = {}) {
    Object.assign(this, data);
  }
}
